import { Grid, Typography } from "@mui/material";
import MainTitle from "../../muiHome/mainTitle";
import BannerCoursesDurationFee from "../../muiCommonComponent/bannerCoursesDurationFee";
import { ListDataPresentation, TableDataPresentation } from "../../../utils/utils";
const pharmad=()=>{
    const progHiglight=[
{listName:'MoU: MVN University is proud to announce the signing of a Memorandum of Understanding (MoU) with Sarvodaya Hospital, Faridabad, to enhance clinical training opportunities for students enrolled in the Doctor of Pharmacy (Pharm.D) program. This strategic collaboration aims to provide students with hands-on clinical exposure, real-time patient care experienceand the opportunity to work alongside leading healthcare professionals in a multidisciplinary hospital setting.'},
{listName:'PCIApproved Curriculum: The Pharm.D programme is designed in accordance with the guidelines of the Pharmacy Council of India (PCI), ensuring high academic standards and regulatory compliance.'},
{listName:'Integrated Clinical Exposure: Students gain hands-on experience through regular hospital postings, clinical rounds and patient case studies in collaboration with reputed healthcare institutions.'},
{listName:'State-of-the-Art Infrastructure: Well-equipped laboratories, modern classrooms and a dedicated hospital training wing support experiential learning and research.'},
{listName:'Focus on Patient Centered Care: Curriculum emphasizes pharmacotherapeutics, clinical pharmacy and patient safety to build competencies in evidence-based practice and medication management.'},
{listName:'Internship & Training: A compulsory one-year internship in a multi-specialty hospital ensures practical exposure to clinical pharmacy services, drug information systems and pharmacovigilance.'},
{listName:'Research and Innovation: Students are encouraged to participate in research projects, national conferences and publications, fostering a strong foundation in scientific inquiry and innovation.'},
{listName:'Career Opportunities: Graduates are prepared for diverse career paths in hospitals, pharmaceutical industries, clinical research organizations (CROs), regulatory bodies, academiaand global healthcare settings.'},
    
    ]
    const feeStructureData=[
        {duration:'1st Year Onwards Fees','6 Years':'₹195000/- (Tuition Fee - ₹175000 + Other Charges- ₹20000/-)'},
        // {duration:'2nd Year Onwards Fees','2 Years':'₹87000/- ( Tuition Fee – ₹70000 + Other Charges- ₹20000/-)'}
    ]
    const hostalFeeData=[
        {item:'Triple Seater with Meal','fee':'₹ 96000/-'},
        {item:'Triple Seater (AC) with Meal','fee':'₹130000/-'}
    ]
    const duration='5+1 (6Years)'
    const fee_1st= '1,95,000'
    const fee_2nd= '1,95,000'
    const eligibility='Candidate shall have passed 10+2 examination conducted by the respective state/central government authorities recognized as equivalent to 10+2 examination by the Association of Indian Universities (AIU) with English as one of the subjects and Physics, Chemistry, Mathematics (P.C.M) and or Biology (P.C.B / P.C.M.B.) as optional subjects individually. Any other qualification approved by the Pharmacy Council of India as equivalent to any of the above examinations.'
return (
<Grid container spacing={2}>
<Grid item xs={12}>
<BannerCoursesDurationFee duration={duration} fee_1st={fee_1st} fee_2nd={fee_2nd} eligibility={eligibility}/>
    </Grid>
<Grid item xs={12}>
    <MainTitle title="Pharm. D" />
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="About the Program" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    The Pharm. D program at the School of Pharmaceutical Sciences, MVN University, Palwal, has quickly become a cornerstone for aspiring researchers in the pharmaceutical field since its inception in 2024. Designed to meet the growing demands of the research community, the program has consistently fostered an environment conducive to excellent research work.One of the key strengths of the program lies in its dedicated faculty members who bring a wealth of knowledge and experience to the classroom and research labs. Their guidance and mentorship play a pivotal role in nurturing the talents of students and facilitating ground breaking research. Moreover, the program's strategic tie-ups with top-notch companies further enhance the learning experience by providing students with opportunities for practical exposure and industry-relevant projects. These collaborations not only enrich the curriculum but also open doors to potential career pathways for students. 
    </Typography>
    <br></br>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Overall, the Pharm. D program at the School of Pharmaceutical Sciences, MVN University, Palwal, stands out as a beacon of excellence in pharmaceutical education and research, shaping the future leaders and innovators of the field.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Eligibility" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" fontWeight={800} >
    Minimum Eligibility Criteria <br/><br/>
    </Typography>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" fontWeight={800} >
        Minimum qualification for admission in Pharm. D
    </Typography>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        Educational Qualification: Passed 10+2 examination with Physics and Chemistry as compulsory subjects along with one of the following: Mathematics or Biology.
    </Typography>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        Minimum Marks: At least 50% aggregate marks in qualifying examination (Relaxation applicable as per norms).
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Programme Highlights" />
    </Grid>

    <Grid item xs={12}>
    <ListDataPresentation DataList={progHiglight}/>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Fee Structure" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Our comprehensive fee structure is fully transparent, enabling you and your family to plan confidently for the entire duration of the program. Although the program spans six years (5+1), fees are charged only for the first five years. Below, you will find a detailed breakdown of tuition fees, including specific costs for the first year and subsequent years.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" alignItems={'center'} fontWeight={800}>
    D.Pharma
    </Typography>
    <TableDataPresentation data={feeStructureData}/>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Ensure your comfort and convenience while studying at our institution with our range of hostel accommodations. We offer various options to suit your preferences, including triple seater rooms, both air-conditioned and non-air-conditioned, complete with meal plans. Below, you’ll find detailed information on our hostel fee structures for each option.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" alignItems={'center'} fontWeight={800}>
    Hostel Fee
    </Typography>
    <TableDataPresentation data={hostalFeeData}/>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    <b>Note:</b> Hostel Caution Money of ₹10,000/- One Time Payment (Refundable) <br/><br/>
    </Typography>
    </Grid>
    </Grid>

)
}
export default pharmad;